var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowforwardsquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71224 18.3334H12.7122C16.8789 18.3334 18.5456 16.6667 18.5456 12.5001V7.50008C18.5456 3.33341 16.8789 1.66675 12.7122 1.66675H7.71224C3.54557 1.66675 1.87891 3.33341 1.87891 7.50008V12.5001C1.87891 16.6667 3.54557 18.3334 7.71224 18.3334Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7135 12.8167H8.61354C7.19687 12.8167 6.04688 11.6667 6.04688 10.25C6.04688 8.83335 7.19687 7.68335 8.61354 7.68335H14.2552",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0703 8.9751L14.3786 7.65843L13.0703 6.3501",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowforwardsquare);
export default __webpack_public_path__ + "static/media/arrowforwardsquare.58eb0732a879a0c97e76fdd8a8b9c9ee.svg";
export { ForwardRef as ReactComponent };